
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Plus, Clock } from 'lucide-react';
import { Spinner } from '@/components/Spinner';

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  loading: boolean;
  lastSearched: string[];
  onSearchTermClick: (term: string) => void;
  onShowCustomForm: () => void;
  showCustomForm: boolean;
  showSelectedFood: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  loading,
  lastSearched,
  onSearchTermClick,
  onShowCustomForm,
  showCustomForm,
  showSelectedFood
}) => {
  return (
    <div className="space-y-4">
      {/* Main search bar */}
      <div className="relative">
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
          {loading ? (
            <Spinner size="sm" />
          ) : (
            <Search size={20} className="text-green-500" />
          )}
        </div>
        <Input
          type="text"
          placeholder="Buscar alimentos (ej: plátano, avena, tofu...)"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-12 pr-4 py-3 text-base border-2 border-gray-200 focus:border-green-400 focus:ring-green-400 rounded-xl transition-all duration-200"
        />
      </div>

      {/* Recent searches */}
      {lastSearched.length > 0 && !searchTerm && !showSelectedFood && !showCustomForm && (
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Clock size={16} />
            <span>Búsquedas recientes:</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {lastSearched.slice(0, 5).map((term, index) => (
              <Button 
                key={index} 
                variant="outline" 
                size="sm"
                className="text-xs px-3 py-1.5 h-auto border-green-200 text-green-700 hover:bg-green-50 hover:border-green-300 rounded-full transition-all duration-200"
                onClick={() => onSearchTermClick(term)}
              >
                {term}
              </Button>
            ))}
          </div>
        </div>
      )}
      
      {/* Custom food button */}
      {!showSelectedFood && !showCustomForm && (
        <div className="flex justify-center pt-2">
          <Button 
            variant="outline" 
            size="sm" 
            className="text-sm px-4 py-2 border-dashed border-2 border-green-300 text-green-700 hover:bg-green-50 hover:border-green-400 rounded-xl transition-all duration-200"
            onClick={onShowCustomForm}
          >
            <Plus size={16} className="mr-2" /> 
            Crear alimento personalizado
          </Button>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
